import RolesChecker from 'features/customer/components/RolesChecker';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { loadPortalConfig } from 'features/shared/helpers/modules';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import InvoiceSimulationDetailSection from './sections/InvoiceSimulationDetailSection';
import InvoiceSimulationSection from './sections/InvoiceSimulationSection';

const portalConfig = loadPortalConfig();

type Props = {}

const InvoiceSimulation = (props: Props) => {
  let match = useRouteMatch();

  // translations
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <RenderWrapper 
      isVisible={() => portalConfig.enableInvoiceSimulation}
      noVisibleRedirect="/"
    >
      <Switch>
        <Route path={`${match.path}/detail/:id`}>
          <Header
            title={t("invoiceSimulationDetail.title")}
            includeBreadcrumbs
            links={[
              { text: t("invoiceSimulationCalculation.title"), to: `${match.path}` },
            ]}
          />
          <ModuleContent>
            <RolesChecker enabledRoles="Contributor">
              <InvoiceSimulationDetailSection />
            </RolesChecker>
          </ModuleContent>
        </Route>
        <Route path={`${match.path}`}>
          <Header title={t("invoiceSimulationCalculation.title")} includeBreadcrumbs />
          <ModuleContent>
            <RolesChecker enabledRoles="Contributor">
              <InvoiceSimulationSection />
            </RolesChecker>
          </ModuleContent>
        </Route>      
      </Switch>
    </RenderWrapper>
  );
}

export default InvoiceSimulation;